var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._g(_vm._b({staticClass:"bank-image",attrs:{"src":_vm.src,"alt":_vm.altText,"width":_vm.width,"height":_vm.height}},'img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }